import React from 'react'
import { ReactComponent as Icon } from '../../assests/projectSuitcase.svg'
import { DESCRIPTIONCONFIG } from '@configure/label-config';

const TopTitleWithButton = ({
    icon = <Icon />,
    title = 'People Directory',
    subtitle = DESCRIPTIONCONFIG.RM_PEOPLE,
    onClick = (() => { }),
    btnName = 'New Project',
    isNeedIcon = true,
    ...props
}) => {
    return (

            <div className='flex flex-col gap-2'>
                <div className='flex gap-2 justify-between w-full items-center'>
                    <div className='flex gap-2 items-center'>

                    {isNeedIcon &&
                    <div>
                        {icon}
                    </div>
                    }
                    <h1 className="text-2xl font-bold text-foreground">
                        {title}
                    </h1>
                    </div>
                    {props?.rightComponent && props?.rightComponent}
                </div>
                <p className="text-base text-muted-foreground">{subtitle}</p>
            </div>

    );
}

export default TopTitleWithButton
